import { inject, Injectable, signal } from '@angular/core';
import { FilesService } from 'app/shared/files.service';
import { HttpUtils } from 'app/shared/http-utils';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AvatarService {
  private files = inject(FilesService);
  private avatarApiUrl = HttpUtils.getApiUrl('/files/avatars');
  private uploadAvatarApiUrl = HttpUtils.getApiUrl('/files/avatars/upload');

  avatarUrl = signal<string | null>(null);

  getAvatar(userId: string | number) {
    return this.files.getFile(`${this.avatarApiUrl}/${userId}`).pipe(tap((res) => this.avatarUrl.set(res.url)));
  }

  uploadAvatar(file: File) {
    return this.files.uploadFile(file, this.uploadAvatarApiUrl).pipe(tap((res) => this.avatarUrl.set(res.url)));
  }
}
